<template>
  <div class="area-select-component">
    <Spin v-if="loading"></Spin>
    <Menu v-if="mTab" :mode="mMode" :active-name="mTab"
          ref="tab" :style="$attrs.style" class="menu-area"
          @on-select="onRegionSelect">
      <MenuItem v-for="(reg, i) in mCurr"
                :key="i" :name="''+i">{{reg.label}}</MenuItem>
      <MenuItem v-if="mLast && mCurr.length==0" name="0">{{header}}</MenuItem>
    </Menu>
    <div v-if="mLast" style="text-align: left;width: 100%;">
      <Tag v-for="(item, ii) in mLast" :key="ii" color="orangered"
           :checkable="true" :checked="false" type="border" style="cursor: pointer;"
           @on-change="checkTag(item)">{{item.label}}</Tag>
    </div>
  </div>
</template>

<script>
    /** 地址区域选择**/
    export default {
        name: 'AreaSelect',
        props: {
            header: {
                default: 'Area'
            },
            mode: String,
            value: Array,
            maxLen: {
                type: Number,
                default: 20
            }
        },
        data () {
            return {
                loading: false,
                mAreaData: null,
                mValue: null,
                mCurr: [],
                mLast: null,
                mTab: null,
                mMode: null
            }
        },
        methods: {
            loadData () {
                if (this.$store.state.areas) {
                    this.onDataLoaded(this.$store.state.areas);
                    return;
                }
                this.loading = true;
                this.$store.dispatch('loadAreas').then((res) => {
                    this.onDataLoaded(res);
                }).catch(() => {
                }).finally(() => {
                    this.loading = false;
                });
            },
            onDataLoaded (data) {
                this.mAreaData = [];
                // todo: 158仅台湾
                for (const i in data) {
                    if (data[i].id === 158) {
                        this.mAreaData.push(data[i]);
                        break;
                    }
                }
                this.mLast = this.mAreaData;
                this.updateValue(this.value);
            },
            onRegionSelect (name) {
                const index = parseInt(name);
                if (index < this.mCurr.length) {
                    this.mCurr.splice(index);
                    this.onValueChanged();
                    if (index === 0) {
                        this.mLast = this.mAreaData;
                    } else {
                        this.setLastItem(this.mCurr[index - 1]);
                    }
                }
                this.updateTab('' + this.mCurr.length);
            },
            checkTag (item) {
                this.mCurr.push(item);
                this.onValueChanged();
                this.setLastItem(item);
                this.updateTab('' + this.mCurr.length);
            },
            setLastItem (item) {
                if (item === this.mAreaData) {
                    this.mLast = item;
                } else if (item && item.children && item.children.length > 0 && this.mCurr.length < this.maxLen) {
                    this.mLast = item.children;
                } else {
                    this.mLast = null;
                }
            },
            updateTab (tab) {
                this.mTab = tab;
                if (tab == null) {
                    return;
                }
                this.$nextTick(() => {
                    this.$refs.tab.updateActiveName();
                })
            },
            isSame (val) {
                if (!val && this.mCurr.length === 0) {
                    return true;
                }
                if (val && this.mCurr && val.length === this.mCurr.length) {
                    for (const i in val) {
                        if (val[i] !== this.mCurr[i].id) {
                            return false;
                        }
                    }
                    return true;
                }
                return false;
            },
            updateText (text) {
                if (this.mValue !== text) {
                    this.mValue = text;
                    this.$emit('on-change', text);
                }
            },
            onValueChanged () {
                let val = '';
                for (const i in this.mCurr) {
                    if (val) {
                        val += ' ';
                    }
                    val += this.mCurr[i].label;
                }
                this.updateText(val);
                if (!this.isSame(this.value)) {
                    const ids = this.mCurr.length > 0 ? [] : null;
                    for (const i in this.mCurr) {
                        ids.push(this.mCurr[i].id);
                    }
                    this.$emit('input', ids);
                }
            },
            updateValue (val) {
                // 根据val构造
                let areas = this.mAreaData;
                if (!areas || areas.length === 0) {
                    this.updateText('');
                    this.updateTab(null);
                    return;
                }
                let tab = '0';
                this.mCurr.splice(0);
                if (!val) {
                    this.mLast = areas;
                    this.onValueChanged();
                    this.updateTab(tab);
                    return;
                }
                for (const i in val) {
                    const id = val[i];
                    let found = false;
                    for (const j in areas) {
                        const item = areas[j];
                        if (item.id === id) {
                            this.mCurr.push(item);
                            tab = '' + id;
                            areas = item.children;
                            found = true;
                            break;
                        }
                    }
                    if (!found) {
                        break;
                    }
                    if (!areas || areas.length === 0) {
                        areas = null;
                        break;
                    }
                }
                this.setLastItem(areas);
                this.onValueChanged();
                this.updateTab(tab);
            }
        },
        watch: {
            value (val) {
                // 判断是否相同
                if (this.isSame(val)) {
                    return;
                }
                this.updateValue(val);
            }
        },
        mounted () {
        },
        created () {
            this.mMode = this.mode;
            if (this.mMode !== 'horizontal') {
                if (window.screen.width < 350) {
                    this.mMode = 'vertical';
                } else {
                    this.mMode = 'horizontal';
                }
            }
            this.loadData();
        },
        beforeDestroy () {
            if (this.cancel) {
                this.cancel();
                this.cancel = null;
            }
        }
    }
</script>

<style lang="scss">
  .area-select-component {
    .ivu-menu-horizontal {
      height: 40px;
      line-height: 40px;
    }
    .ivu-menu-item {
      padding: 0 5px;
    }
    .menu-area {
      width: 100%;
      z-index: 0;
    }
  }
</style>
